"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Reselect = require("reselect");
var NestedProjectExplorerCell_1 = require("./dataGridCells/NestedProjectExplorerCell");
var NestedProjectsFractalRowStore_1 = require("./NestedProjectsFractalRowStore");
var TreeViewComponent_1 = require("./TreeViewComponent");
// We could call setItems() on the row store instead of creating a whole new one, but this is not
// optimized because we currently don't have the use case of sending in new projects.
function buildRowStore(projects, siteName, topLevelDestinationStatus, rowExpansionHandler) {
    return new NestedProjectsFractalRowStore_1.NestedProjectsFractalRowStore(projects, siteName, rowExpansionHandler, topLevelDestinationStatus);
}
var NestedProjectExplorer = /** @class */ (function (_super) {
    __extends(NestedProjectExplorer, _super);
    function NestedProjectExplorer(props) {
        var _this = _super.call(this, props) || this;
        _this.memoizedBuildRowStore = Reselect.defaultMemoize(buildRowStore);
        _this.memoizedGetDestinationProjectCellFormatter = Reselect.defaultMemoize(NestedProjectExplorerCell_1.getDestinationProjectCellFormatter);
        _this.rowExpansionHandler = function (rowKey) {
            _this.rowStore.toggleExpansionForItemKey(rowKey);
            _this.forceUpdate();
        };
        _this.onProjectSelected = function (newProject) {
            if (newProject.status !== 'valid') {
                return;
            }
            var currentSelectedId = _this.state.selectedProjectId;
            var rowAlreadySelected = currentSelectedId !== null && currentSelectedId === newProject.id;
            if (rowAlreadySelected) {
                _this.setState({ selectedProjectId: null });
                _this.props.onSelectedProjectChanged(null);
            }
            else {
                _this.setState({ selectedProjectId: newProject.id });
                _this.props.onSelectedProjectChanged(newProject);
            }
        };
        _this.state = {
            selectedProjectId: props.initiallySelectedProjectId || null
        };
        return _this;
    }
    NestedProjectExplorer.prototype.render = function () {
        // Make a new row store when and only when the relevant props change
        this.rowStore = this.memoizedBuildRowStore(this.props.projects, this.props.siteName, this.props.topLevelDestinationStatus, this.rowExpansionHandler);
        var treeViewProps = {
            cellFormatter: this.memoizedGetDestinationProjectCellFormatter(),
            rowStore: this.rowStore,
            selectedItemId: this.state.selectedProjectId,
            onItemClicked: this.onProjectSelected,
        };
        return React.createElement(TreeViewComponent_1.TreeViewComponent, __assign({}, treeViewProps));
    };
    return NestedProjectExplorer;
}(React.PureComponent));
exports.NestedProjectExplorer = NestedProjectExplorer;
//# sourceMappingURL=NestedProjectExplorerComponent.js.map